module.exports = __webpack_public_path__ + "img/照片01.c29a9fe3.svg";